import { render } from "./HistoricalEntitlementUsageCharts.vue?vue&type=template&id=2974f690"
import script from "./HistoricalEntitlementUsageCharts.vue?vue&type=script&lang=js"
export * from "./HistoricalEntitlementUsageCharts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__